export var Provider;
(function (Provider) {
    Provider["Twitch"] = "twitch";
    Provider["Google"] = "google";
    Provider["TikTok"] = "tiktok";
})(Provider || (Provider = {}));
